import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';

export const CancelSubscriptionInputValidationSchema = z.object({
  subscriptionId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the subscription you intend to cancel. This tool returns eligibility, side effects, and a dashboard link — it does NOT perform the cancellation.',
  }),
});
